import { useKeycloak } from "@react-keycloak/web";
import { Fragment, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Role } from "../types/index.type";

type AuthMiddlewareProps = {
  children: ReactNode;
  roles: Role[];
};

export default function AuthMiddleware({
  children,
  roles,
}: AuthMiddlewareProps) {
  const { keycloak } = useKeycloak();
  // const { token, role } = useAppSelector((state) => state.auth);
  // const accessRole = role && roles?.length && roles?.includes(role);
  // const isAuth = useAuth(roles);
  const isAuth = keycloak?.authenticated && keycloak?.token;

  if (isAuth) {
    return <Fragment>{children}</Fragment>;
  }

  return <Navigate to="/admin/login" />;
}
